import { render, staticRenderFns } from "./cpiCustomListTab.vue?vue&type=template&id=6e297b56&lang=pug"
import script from "./cpiCustomListTab.vue?vue&type=script&lang=js"
export * from "./cpiCustomListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports